import React, { Component } from "react";
import SelfRegistrationForm from "../../components/Forms/SelfRegistrationForm";
import axios from "../../services/api/api";

class StudentSelfRegistration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: null,
      email: null,
      role: null,
      token: null
    };
  }

  componentDidMount() {
    if (this.props.location.search) {
      const checkSum = this.props.location.search.split("?check=")[1];
      axios
        .get("/User/Validation?email=" + encodeURIComponent(checkSum))
        .then(response => {
          this.setState({
            name: response.data.result.name,
            email: response.data.result.email,
            role: response.data.result.role,
            validationtoken: response.data.result.validationToken
              ? response.data.result.validationToken
              : null
          });
        })
        .catch(err => {
          this.setState({
            name: null,
            email: null,
            role: null
          });
        });
    }
  }

  render() {
    return (
      <SelfRegistrationForm
        validationtoken={this.state.validationtoken}
        email={this.state.email}
        role={this.state.role}
      />
    );
  }
}

export default StudentSelfRegistration;
